import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";

const PromocionesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const eliminarItem = (id) => {
    console.log('eliminarItem', id);
    setIsLoading(true);
    try {
      fetch(`/api/promotions/${id}`,{
        method: "DELETE",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setDatos([])
        cargarDatos();
      });
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const [datosTabla] = useState({
    titulo: "Promociones",
    ruta: "/promocion",
    esAgregar: true,
    esEditar: true,
    esEliminar: true,
    eliminar: eliminarItem,
    configTable: configTable,
    keySucursal: "ID_SUC_PRS"
  })

  const [cabecera] = useState([
    { title: "ID", key: "id" },
    { title: "NOMBRE", key: "nombre" },
    { title: "ACTIVO", key: "activo" },
    { title: "SUCURSAL", key: "sucursal.nombre" },
    { title: "FECHA ALTA", key: "createdAt", isDate: true }
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/api/promotions",{
        method: "GET",
        headers:{
          "Content-Type": "application/json",
        }
      })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if(data.status){
          setDatos(data.data);
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
      { isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera}/> }
      </MasterLayout>
    </>
  );
};

export default PromocionesPage;
